/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_IntroInputs */

const en_us2_clubs_intro = /** @type {(inputs: Clubs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A club is a challenge among friends: each person chases their own goal, and the group adds up together. Only what you log in the app counts.`)
};

const pt_br2_clubs_intro = /** @type {(inputs: Clubs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um clube é um desafio entre amigos: cada um busca a própria meta, e o grupo soma junto. Só conta o que você registra no app.`)
};

const es_419_clubs_intro = /** @type {(inputs: Clubs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un club es un desafío entre amigos: cada uno persigue su propia meta y el grupo suma en conjunto. Solo cuenta lo que registras en la app.`)
};

const pt_pt2_clubs_intro = /** @type {(inputs: Clubs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um clube é um desafio entre amigos: cada um persegue o seu próprio objetivo e o grupo soma em conjunto. Só conta o que registas na app.`)
};

const fr_fr2_clubs_intro = /** @type {(inputs: Clubs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un club est un défi entre amis : chacun poursuit son propre objectif, et le groupe additionne le tout. Seul ce que tu enregistres dans l'appli compte.`)
};

const de_de2_clubs_intro = /** @type {(inputs: Clubs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Club ist eine Challenge unter Freunden: Jede Person verfolgt ihr eigenes Ziel, und die Gruppe zählt zusammen. Es zählt nur, was du in der App erfasst.`)
};

const it_it2_clubs_intro = /** @type {(inputs: Clubs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un club è una sfida tra amici: ognuno insegue il proprio obiettivo e il gruppo somma insieme. Conta solo ciò che registri nell'app.`)
};

/**
* | output |
* | --- |
* | "A club is a challenge among friends: each person chases their own goal, and the group adds up together. Only what you log in the app counts." |
*
* @param {Clubs_IntroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_intro = /** @type {((inputs?: Clubs_IntroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_IntroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_intro(inputs)
	if (locale === "es-419") return es_419_clubs_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_intro(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_intro(inputs)
	if (locale === "de-DE") return de_de2_clubs_intro(inputs)
	if (locale === "it-IT") return it_it2_clubs_intro(inputs)
	return en_us2_clubs_intro(inputs)
});
export { clubs_intro as "clubs.intro" }